<template>
  <div class="dayplanner-suggestions">
    <!-- <h3>Planning the perfect day</h3> -->
    <!-- <h3>What's up today?</h3> -->

    <h5 class="text-center p-2 bg-dark text-light rounded ">Scheduled for {{view_selected_date|longDate}}</h5>

    <div v-for="tsc in timeslotCollections" :key="tsc.$id" style="margin-top: 2em;">
      <div class="rotate-wrapper" style="display: flex; flex-wrap: nowrap;">
        <!-- <div class="rotate" style="font-size: 10pt; text-transform: uppercase; border: 1px solid red;" >&nbsp;</div> -->
        <div :style="'width:5px; margin-right: 0.5em; background-color: ' + tsc.color"></div>
        <div style="display: flex; flex-direction: column" class="w-100">
          <suggestion-category-header
            :name="tsc.name"
            :magic-timeslots="timeslotsTodayByTsc( tsc )"
            :tscId="tsc.$id"
            :icon="tsc.icon"
          />

          <suggestion-drag-list :item-list="commitment_suggestion_items.items[ tsc.$id ]" :clone="cloneItem">
            <component
              class="action-draggable"
              v-for="suggestion_item in commitment_suggestion_items.items[ tsc.$id ]"
              v-bind:is="suggestion_item.componentSuggestion"
              :key="suggestion_item.$key"
              :item-id="suggestion_item.$id"
              :config="suggestion_item.config"
              :magic-timeslots="timeslotsTodayByTsc( tsc )"
              :name="suggestion_item.title"
              :tsc-color="tsc.color"
              :hide-if-not-planned="true"
              @add="onAddSuggestionItem(commitment_suggestion_items.$id, suggestion_item, $event)"
            />
            <!--
              :date-timestamp="view_selected_date_as_timestamp /* TODO: REMOVE */"
              :magic-timeslots="timeslots_today.filter(item => item.tscId === tsc.$id) /* TODO: REMOVE */"
              :dayplan="dayplan_from_db /* TODO: REMOVE */"
              :dayplan_remaining_timeslots="dayplan_remaining_timeslots /* TODO: REMOVE */"
              :current_date="view_selected_date_as_yymmdd /* TODO: REMOVE */"
            -->
          </suggestion-drag-list>
        </div>
      </div>
    </div>
    <div class="pt-2">
      <a href="#" @click.prevent="show_unassigned = !show_unassigned">{{ show_unassigned ? 'Hide' : 'Show' }} unassigned</a>
    </div>

    <el-alert type="info" class="mt-4">
      Design your perfect day by adding today's agenda items to you day plan on the right.
      Clicking 'Add' will automatically find the best possible time and duration.
    </el-alert>

    <!-- <pre class="mini-pre">{{ commitment_list_all.map(commitment => commitment.user.timeslotCollectionId) }}</pre> -->

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapReady } from "@/api/misc";
import Draggable from "vuedraggable";

import ItemTasklist from "./Suggestions/ItemTasklist";
import ItemSequence from "./Suggestions/ItemSequence";
import ItemAmount from "./Suggestions/ItemAmount";
import ItemHabit from "./Suggestions/ItemHabit";

import SuggestionCategoryHeader from "./SuggestionCategoryHeader";
import SuggestionDragList from "./SuggestionDragList";

import { make_block } from "../API/util";

import clonedeep from "lodash.clonedeep";
import util from "@/util";
import moment from "@/moment-gp.js";
import SessionManagementMixin from "@/components/Mixins/SessionManagement"
import SuggestionItemMixin from './Suggestions/SuggestionItemMixin.js'

export default {
  mixins: [SessionManagementMixin, SuggestionItemMixin],
  props: {
  },
  data: () => ({
    show_unassigned: false,
    collapse_list: [3]
  }),
  computed: {
    ...mapReady("commitments"),
    ...mapGetters("timeslots", ["get_timeslot_flat_cache"]),
    ...mapGetters("dayplanner", [
      "view_selected_date",
      // "dayplan_remaining_timeslots",
      // "dayplan_from_db",
      // "view_selected_date_as_timestamp",
      // "view_selected_date_as_yymmdd",
    ]),

    commitment_suggestion_items() {
      return {
        $id: 2,
        title: "My Daily Goals",
        items: this.myday_suggestions,
        componentSuggestion: "item-tasklist",
        type: "CATEGORY"
      };
    },

    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    commitment_list_all() {
      return clonedeep(
        this.$models.commitment.getters.commitment_list_all
      ).sort(util.sorter.by_user_prioidx);
    },

    timeslotCollections() {
      let timeslot_collection_list_enhanced = this.timeslot_collection_list.map(
        tsc => {
          let commitmentsFound = this.commitment_list_all.find(
            commitment => commitment.user.timeslotCollectionId === tsc.$id
          );
          if (commitmentsFound) {
            return Object.assign(tsc, {
              icon: {
                symbol: "filter",
                bgColor: tsc.$state.color,
                fgColor: "#ffffff"
              },
              hasCommitments: 1
            });
          } else {
            return Object.assign(tsc, {
              icon: {
                symbol: "filter",
                bgColor: tsc.$state.color,
                fgColor: "#ffffff"
              },
              hasCommitments: 0
            });
          }
        }
      );

      let unassigned = {
        $id: null,
        name: 'Unassigned',
        color: 'red',
        hasCommitments: 0,
        icon: {
          symbol: "filter",
          bgColor: 'red',
          fgColor: "#ffffff"
        },
      }
      if ( this.show_unassigned ) {
        timeslot_collection_list_enhanced.push(unassigned);
      }
      return timeslot_collection_list_enhanced;
    },

    timeslots_today() { // --> mixin
      let tscData = {};

      this.timeslot_collection_list.forEach(tsc => {
        tscData[tsc.$id] = {
          name: tsc.$state.name,
          color: tsc.$state.color
        };
      });

      let visibleRangeFrom = this.view_selected_date.clone().startOf("day")
      let visibleRangeEnd = this.view_selected_date.clone().endOf("day")
      let flattened_timeslots_new = [];
      if (this.get_timeslot_flat_cache) {
        Object.keys(this.get_timeslot_flat_cache).forEach(tscId => {
          let event_data = this.get_timeslot_flat_cache[tscId].event_data;
          let nrElements = event_data.length;
          for (let i = 0; i < nrElements; i++) {
            let event = event_data[i];
            flattened_timeslots_new.push({
              tscId:    tscId,
              from:     event.from,
              to:       event.to,
              start:    moment.unix(event.from), // moment obj?
              end:      moment.unix(event.to),
              devStart: moment.unix(event.from).format(),
              devEnd:   moment.unix(event.to).format(),
              title: tscData[tscId].name,
              color: tscData[tscId].color,
              data: {
                source: "TSC",
                duration: (event.to - event.from) / 60
              },
              timeslotId: event.timeslotId,
              enabled: true
            });
          }
        });
      }
      //console.log('timeslot_collection_list from', visibleRangeFrom, ' to',  visibleRangeEnd)
      return flattened_timeslots_new.filter(
        event => event.end >= visibleRangeFrom && event.start <= visibleRangeEnd
      );
    },

    myday_suggestions() {
      if (!this.$ready_commitments) {
        return [];
      }

      function get_component_name( commitment ) { // <<< mixin
        if ( commitment.type === 'TIME_BASED_TASKLIST' ) {
          return 'item-tasklist'; // TODO !!!!!
        }
        return 'item-' + commitment.type.toLowerCase()
      }

      let items = {};
      let itemIndex = 1;
      this.timeslotCollections.forEach(tsc => {
        this.commitment_list_all
          .filter(
            commitment =>
              ( commitment.user.timeslotCollectionId || null ) === tsc.$id &&
              commitment.active
          )
          .forEach(commitment => {
            if ( !( tsc.$id in items ) ) {
              items[ tsc.$id ] = []
            }
            // console.log('myday_suggestions commitment', tsc, commitment, 'type:', commitment.type)
            items[ tsc.$id ].push({
              $key: itemIndex,
              $id:  commitment.commitmentId,
              $groupId: 'default',
              ...make_block(commitment.type, null, null, commitment.meta.name, {
                goalId: commitment.goalId,
                commitmentId: commitment.commitmentId,
                tscId: tsc.$id,
                tscColor: tsc.icon.bgColor
              }),
              componentSuggestion: get_component_name( commitment ),
            });
            itemIndex += 1;
          });
      });
      return items;
    },
  },
  methods: {

    timeslotsTodayByTsc(tsc) {
      return this.timeslots_today.filter(item => item.tscId === tsc.$id);
    },

    cloneItem(item) {
      //this.onDragAddItem(item.type, itemPlacementConfig)
      let item_clone = clonedeep(item);
      item_clone.id = item_clone.$id;
      item_clone.groupId = item_clone.$groupId;

      delete item_clone.$key; /* remove key */
      delete item_clone.$id; /* remove key */
      delete item_clone.$groupId; /* remove key */

      item_clone.description = null; /* Remove description, so user can set it */
      item_clone.just_dropped = true;

      Object.assign(item_clone, {
        dragConfig: {
          duration: 3600, //this.session_duration_today,
          placeAtEnd: false,
          shiftingEnabled: true
        }
      })

      if (item_clone.type === 'SEQUENCE') {
        //console.log('sequence detected before', item_clone)
        Object.assign(item_clone, { sequenceItems: this.getSequenceTasks(item_clone.config.commitmentId, this.view_selected_date.format('YYMMDD')) })
        //console.log('sequence detected after', item_clone)
        let sessionPlacementDuration = 0;
        if (item_clone.sequenceItems) {
          item_clone.sequenceItems.forEach(task => {
            sessionPlacementDuration += task.duration;
          });
        }
        item_clone.dragConfig.duration = sessionPlacementDuration
      }
      //console.log("[DND] cloneItem 1", item_clone)
      this.onDragSessionStart(item_clone)
      return item_clone;
    },

    onAddSuggestionItem(groupId, item, $event = {}) {

      // TODO: Refactor!
      console.warn("DEPRECATED")

      let item_clone = this.cloneItem(item);
      console.log('onAddItem', item_clone)

      if ($event.subtype === 'ADHOC_SESSION') {
        console.log('onAddSuggestionItem adding ADHOC_SESSION');
        item.type = 'TASKLIST'
        item.config = $event.config
        item.name = $event.name
        item.component = 'flow-tasklist'
      }

      // Alow to override from / to
      /* TODO:
      if ($event && $event.to) {
        item_clone.to = $event.to;
      }
      */

      // Alow to override from / to or duration
      // Most commonly, it would be: Fixed To + Fixed Duration

      if ( $event && $event.suggestedFrom ) {
        item_clone.devSuggestedFrom = moment.unix( $event.suggestedFrom ).format('LLL')
      }

      Object.assign(item_clone, $event);
      if (item_clone.type === 'SEQUENCE') {
        console.log('onAddItem event before', $event.sequenceItemIds)
        let sequenceItems = []
        $event.sequenceItemIds.forEach(item => {
          sequenceItems.push({ sequenceItemId: item })
        })
        console.log('sequenceItems 2', sequenceItems)

        Object.assign(item_clone, { sequenceItems: sequenceItems })
        delete item_clone.config
        item_clone.type = 'TASKLIST'
        console.log('onAddItem event after', item_clone)
      }

      console.log("onAddSuggestionItem", item_clone, "$event ", $event);
      this.$emit("add", item_clone);
    }
  },
  components: {
    Draggable,
    ItemTasklist,
    ItemSequence,
    ItemAmount,
    ItemHabit,
    SuggestionCategoryHeader,
    SuggestionDragList,
  }
};
</script>

<style>
.dayplanner-suggestions {
  padding: 0.75em;
  height: calc(100vh - 50px); /* = height top menu */
  overflow-y: scroll;
}
.dayplanner-suggestions .el-card.is-always-shadow {
  /* fix shadow */
  box-shadow: 0 4px 7px -3px rgba(0, 0, 0, 0.1);
}
</style>
